<template>
	<div :class="{ hidden: hidden }" class="pagination-container">
		<el-pagination
			:background="background"
			:current-page.sync="currentPage"
			:page-size.sync="pageSize"
			:layout="layout"
			:page-sizes="pageSizes"
			:total="total"
			:disabled="disabled"
			v-bind="$attrs"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
		/>
	</div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to';
import { EventBus } from '@/eventBus';

export default {
	name: 'Pagination',
	props: {
		total: {
			required: true,
			type: Number
		},
		page: {
			type: Number,
			default: 1
		},
		limit: {
			type: Number,
			default: 50
		},
		pageSizes: {
			type: Array,
			default() {
				return [25, 50, 100, 250, 500];
			}
		},
		layout: {
			type: String,
			default: 'total, sizes, prev, pager, next, jumper'
		},
		background: {
			type: Boolean,
			default: true
		},
		autoScroll: {
			type: Boolean,
			default: true
		},
		hidden: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		currentPage: {
			get() {
				return this.page;
			},
			set(val) {
				this.$emit('update:page', val);
			}
		},
		pageSize: {
			get() {
				return this.limit;
			},
			set(val) {
				this.$emit('update:limit', val);
			}
		}
	},
	methods: {
		handleSizeChange(val) {
			console.log('handleSizeChange: ', val);
			EventBus.$emit('paginationSizeChange', {});
			this.$emit('pagination', { page: 1, limit: val });
			this.$emit('paginationSizeChange', {});

			if (this.autoScroll) {
				scrollTo(0, 800);
			}
		},
		handleCurrentChange(val) {
			console.log('handleCurrentChange: ', val);
			this.$emit('pagination', { page: val, limit: this.pageSize });
			if (this.autoScroll) {
				scrollTo(0, 800);
			}
		}
	}
};
</script>

<style scoped>
.pagination-container {
	background: #fff;
	padding: 10px 0;
}
.pagination-container.hidden {
	display: none;
}
</style>
